import { Component, OnInit } from '@angular/core';
import { AuthGuard } from '../service/auth-guard.service';

import { TranslateService } from '@ngx-translate/core';
import { RootService } from '../service/root.service';
declare var lbd: any;
declare var initLight: any;
declare var mobile_menu_visible: any;
@Component({

    selector: 'admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

    constructor(public rootService: RootService, public authGuard: AuthGuard, private translate: TranslateService) { }

    ngOnInit() {
        this.closeSideBar();
        initLight();
        //lbd.initSidebarMenu();
    }
    closeSideBar() {
        $('html').removeClass('nav-open');

        $('.close-layer').remove();
        setTimeout(function () {
            $('.navbar-toggle').removeClass('toggled');
        }, 400);

        mobile_menu_visible = 0;
    }

}


// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts